module.exports = __webpack_public_path__ + "media/images/emblems/Huentwangen-blazon-602a36dbdac2079b9eb84ae2ee136922.svg";